import React from 'react';
import { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { acceptOrRejectPracticeInvitationService } from 'Services/libre_api';
import { addPracticeService, removePracticeService, validatePracticeService, } from 'Services/libre_api';
const useLibrePractice = () => {
    const acceptOrRejectPracticeInvitation = useCallback(async (invitationID, action) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        try {
            const practiceConnection = await acceptOrRejectPracticeInvitationService(invitationID, user.id, action, osType, osVersion, app, appVersion);
            if (practiceConnection) {
                return { practiceConnection };
            }
            return {};
        }
        catch (err) {
            const error = err;
            const errorCode = error.response?.data.code;
            return { errorCode };
        }
    }, []);
    const validatePractice = useCallback(async (businessID) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        try {
            const practiceBody = await validatePracticeService(businessID, user.id, osType, osVersion, app, appVersion);
            return { practiceBody };
        }
        catch (err) {
            const error = err;
            const errorCode = error.response?.data.code;
            return { errorCode };
        }
    }, []);
    const addPractice = useCallback(async (practiceID) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        try {
            const practiceBody = await addPracticeService(practiceID, user.id, osType, osVersion, app, appVersion);
            return { practiceBody };
        }
        catch (err) {
            const error = err;
            const errorCode = error.response?.data.code;
            return { errorCode };
        }
    }, []);
    const removePractice = useCallback(async (practiceID) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        return removePracticeService(practiceID, user.id, osType, osVersion, app, appVersion);
    }, []);
    const showStopSharingModal = useCallback((onRemoveClick) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: {
                buttonLayout: 'column',
                details: (React.createElement(Stack, null,
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.strong", fontSize: "$bodyBase.strong", testID: "StopSharingModal.title", marginBottom: "$4" }, i18n.t('Global.modals.stopSharing.title')),
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default", testID: "StopSharingModal.body" }, i18n.t('Global.modals.stopSharingPractice.body')))),
                primaryAction: {
                    label: i18n.t('Global.modals.stopSharing.title'),
                    destructive: true,
                    onPress: () => {
                        store.dispatch({
                            type: CLOSE_MODAL,
                        });
                        onRemoveClick();
                    },
                },
                secondaryAction: {
                    label: i18n.t('Global.microcopy.common.cancel'),
                    onPress: () => store.dispatch({
                        type: CLOSE_MODAL,
                    }),
                },
                testID: 'StopSharingModal',
            },
        });
    }, []);
    return {
        showStopSharingModal,
        validatePractice,
        acceptOrRejectPracticeInvitation,
        addPractice,
        removePractice,
    };
};
export default useLibrePractice;
